var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59125 2.57359C4.64993 1.40305 6.46713 1.35958 7.58 2.47819L8.45312 3.35581C9.52959 4.43782 9.52959 6.19212 8.45312 7.27413L8.36421 7.36351C9.53965 8.94725 10.9354 10.354 12.5092 11.5405L12.5988 11.6081L12.6818 11.5246C13.7583 10.4426 15.5036 10.4426 16.5801 11.5246L17.5263 12.4757C18.6028 13.5578 18.6028 15.312 17.5263 16.3941L16.4043 17.5218C15.4214 18.5099 13.8602 18.6075 12.7629 17.7497L8.94601 14.7657C7.70926 13.7988 6.5796 12.701 5.57656 11.4911L2.30589 7.54609C1.42526 6.48389 1.45852 4.93168 2.38384 3.90859L3.59125 2.57359ZM6.6804 3.38242C6.08117 2.78009 5.10268 2.8035 4.53262 3.43379L3.32521 4.76878C2.82696 5.31968 2.80905 6.15548 3.28323 6.72744L6.55391 10.6725C7.49852 11.8118 8.56237 12.8457 9.72708 13.7563L13.544 16.7403C14.1348 17.2022 14.9754 17.1496 15.5047 16.6176L16.6267 15.4898C17.2064 14.9072 17.2063 13.9626 16.6267 13.38L15.6805 12.4289C15.1009 11.8463 14.1611 11.8463 13.5814 12.4289L13.1083 12.9044C12.8845 13.1294 12.5301 13.1547 12.2769 12.9638L11.7458 12.5635C9.9541 11.2128 8.37973 9.59305 7.07795 7.76117L7.01259 7.6692C6.83185 7.41486 6.86054 7.06646 7.08042 6.84545L7.55353 6.3699C8.13316 5.78728 8.13316 4.84266 7.55353 4.26004L6.6804 3.38242Z",
    fill: "#FF6319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.5608831a01b344367c777f78656b6723.svg";
export { ForwardRef as ReactComponent };